/**
 * @fileoverview Agent definition for story-image-creator-fal-v2.
 *
 * This agent generates a story scene image from a detailed prompt
 * using the fal.ai provider for high-quality image generation.
 *
 * @category visuals.images.story
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'story-image-creator-fal-v2',
  kind: 'primitive',
  name: 'Story Image Creator (FAL)',
  description: 'Generates a story scene image from a detailed prompt using the fal.ai provider.',
  category: 'visuals',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'visuals.images.story',
    usedBy: [
      'use-writing-visualization-fal-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'story-image-prompt-creator-v2',
      'multi-reference-image-creator-fal-v2',
    ],
  },
};
